import React from 'react'
import __ from './loading.module.css'

const Loading = () => 
  <div className={__.container}>
    <p>Loading <span className={__.ellipsis}>...</span></p>
  </div>

export default Loading